import clientInfo from 'common/lib/clientInfo';
import { useCallback } from 'react';
import { trackProductAnalytics } from 'common/services/product_analytics';

const useTrackCloseClicked = () => {
  const trackCallback = useCallback(() => {
    trackProductAnalytics('Course Outline Generator Close Clicked', {
      'Site ID': clientInfo.get('site_id'),
    });
  }, []);

  return trackCallback;
};

export default useTrackCloseClicked;
